// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";

// API
import { deleteIOLLens } from "../../../api";

export const useDeleteIOLLens = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();
  const { t } = useTranslation();
  const { setSnackbarInfo } = useSnackbarContext();

  return useMutation({
    mutationFn: async (lensId: string) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        return deleteIOLLens(token, clinicId, lensId);
      } catch (error) {
        throw error;
      }
    },
    // Invalidate clinic lens query cache
    onSuccess: (_) => {
      queryClient.invalidateQueries({
        queryKey: ["iol-lenses", clinicId],
      });
      setSnackbarInfo({
        variant: "success",
        message: t("Lens deleted successfully!"),
      });
    },
    onError: () => {
      setSnackbarInfo({
        variant: "error",
        message: t("Lens could not be deleted!"),
      });
    },
  });
};
